import { _AsyncCreatableSelect as AsyncCreatableSelect, _AsyncSelect as AsyncSelect, _ContentBox as ContentBox, _Select } from '../../../../internal';
import { AmountField, Checkbox, DateField, FileUpload, MultiSelect, PhoneField, RadioGroup, Search, SecuredTextField, Select, SelectNew, Switch, TextArea, TextField } from '../../../../selectionAndInputs';
import { createFormFieldInput } from './utils'; // This is exported as a workaround for moving the form widgets from Penny to app.
// This correct way of doing things will be to enable adding logic on top of `Form.X` components

export { createFormFieldInput as _createFormFieldInput };
export var inputs = {
  TextField: createFormFieldInput(TextField),
  TextArea: createFormFieldInput(TextArea),
  SecuredTextField: createFormFieldInput(SecuredTextField),
  AmountField: createFormFieldInput(AmountField),

  /**
   * @deprecated Use `Form.Select` instead
   */
  DeprecatedSelect: createFormFieldInput(_Select),

  /**
   * @deprecated Use `Form.Search` instead
   */
  DeprecatedAsyncSelect: createFormFieldInput(AsyncSelect),

  /**
   * @deprecated Use `Form.Select` or `Form.Search` instead
   */
  DeprecatedAsyncCreatableSelect: createFormFieldInput(AsyncCreatableSelect),
  Select: createFormFieldInput(Select),
  SelectNew: createFormFieldInput(SelectNew),
  Search: createFormFieldInput(Search),
  MultiSelect: createFormFieldInput(MultiSelect),
  RadioGroup: createFormFieldInput(RadioGroup),
  Checkbox: createFormFieldInput(Checkbox),
  DateField: createFormFieldInput(DateField),
  FileUpload: createFormFieldInput(FileUpload),
  PhoneField: createFormFieldInput(PhoneField),
  ContentBox,
  Switch: createFormFieldInput(Switch)
};
//# sourceMappingURL=index.js.map